// apiClient.ts
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { CUS_API_BASE } from './constants';

export const API_CONFIG = {
   BASE_URL: CUS_API_BASE, // Client UAT  URL  
  TIMEOUT: 30000, // 10 seconds
}; 
 
const apiCustomClient = axios.create({
   baseURL: API_CONFIG.BASE_URL ,
  // timeout : API_CONFIG.TIMEOUT,
  headers: {
    "Content-Type": "application/json", 
     "Accept": "application/vnd.api+json",
    // "Accept-Encoding": "gzip, deflate"
  //  'Access-Control-Allow-Origin': '*',
  // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS' 
  },
});
export default apiCustomClient;